import type { IconProps } from '.';

/**
 * Link Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const LinkIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="12"
    viewBox="0 0 22 12"
    fill="none"
    className={className}
  >
    <path
      d="M0.875 6C0.875 2.90625 3.37109 0.375 6.5 0.375H9.875V2.625H6.5C4.63672 2.625 3.125 4.13672 3.125 6C3.125 7.86328 4.63672 9.375 6.5 9.375H9.875V11.625H6.5C3.37109 11.625 0.875 9.12891 0.875 6ZM21.125 6C21.125 9.12891 18.5938 11.625 15.5 11.625H12.125V9.375H15.5C17.3633 9.375 18.875 7.86328 18.875 6C18.875 4.13672 17.3633 2.625 15.5 2.625H12.125V0.375H15.5C18.5938 0.375 21.125 2.90625 21.125 6ZM15.5 4.875V7.125H6.5V4.875H15.5Z"
      fill="white"
    />
  </svg>
);

export default LinkIcon;
